// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { Modal, Col, Row, Button, List } from 'antd';
import { compose } from '../../core';
import { withApollo } from '@apollo/client/react/hoc';
import { getIntFromString, getOrgListFromTeam, getOrgListFromVer, getSurveyBase64StringFromInt, removeDuplicate } from '../../look';
import { withAdminPanelEditSurvey } from './SurveyOperations';
import { IMG } from '../../../config';
import {
  withOrganizationState,
  withAllOrganization,
  withOrganizationFilterUpdating
} from '../../organization/containers/OrganizationOperation';
import SelectFilterField from '../../look/components/SelectFilterField';
import OrganizationTreeSurveyAssign from './OrganizationTreeSurveyAssign';
import { SURVEY_SUBSCRIPTION } from '../graphql/SurveySubscription.gql';

const SurveyAssign = props => {
  const {
    assign,
    setAssign,
    actionLoading,
    setActionLoading,
    SurveyById,
    onFiltersRemove,
    updateSurvey,
    allOrganization,
    onNameChange,
    onDescriptionChange,
    onEmailChange,
    client,
    setSurveyById,
  } = props;
  const [visible, setVisible] = React.useState(false);
  const [orgId, setOrgId] = React.useState(0);
  const [assignedOrgs, setAssignedOrgs] = React.useState({});
  const m = React.useRef(true)
  const [tree, setTree] = React.useState(false);
  const surveySubRef = React.useRef(null);
  const [refreshCounter, setRefreshCounter] = React.useState(0);
  const debounceTimeout = React.useRef(null);
  const DEBOUNCE_INTERVAL = 500; // milliseconds

  const surveySubscription = async () => {
    let id = getSurveyBase64StringFromInt(props.match.params.id);
    surveySubRef.current = await client.subscribe({
      query: SURVEY_SUBSCRIPTION,
      variables: { id },
      fetchPolicy: 'network-only'
    }).subscribe({
      next(result) {
        if (actionLoading) return; // Ignore updates during loading
        switch (result.data.surveySubscription.mutation) {
          case 'UPDATE':
            setSurveyById(result.data.surveySubscription.survey)
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              setRefreshCounter(rc => rc + 1);
            }, DEBOUNCE_INTERVAL);
            break;
          default:
            break
        }
      }
    })
  }


  React.useEffect(() => {
    return () => {
      m.current = false
    }
  }, [])

  React.useEffect(() => {
    m.current = true

  }, [])

  React.useEffect(() => {
    if (SurveyById) {
      surveySubscription()
      const assignedOrg = removeDuplicate([
        ...((SurveyById?.organization && SurveyById?.organization?.edgeCount > 0 && SurveyById?.organization?.edges) || []),
        ...((SurveyById?.vertical && SurveyById.vertical?.edgeCount > 0 && getOrgListFromVer(SurveyById.vertical).edges) || []),
        ...((SurveyById?.team && SurveyById.team?.edgeCount > 0 && renderOrgList(getOrgListFromTeam(SurveyById.team)).edges) ||
          [])
      ]);
      setAssignedOrgs(assignedOrg)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCounter])

  function triggerSubscriptionFetch() {
    if (SurveyById) {
      surveySubscription()
      const assignedOrg = removeDuplicate([
        ...((SurveyById?.organization && SurveyById?.organization?.edgeCount > 0 && SurveyById?.organization?.edges) || []),
        ...((SurveyById?.vertical && SurveyById.vertical?.edgeCount > 0 && getOrgListFromVer(SurveyById.vertical).edges) || []),
        ...((SurveyById?.team && SurveyById.team?.edgeCount > 0 && renderOrgList(getOrgListFromTeam(SurveyById.team)).edges) ||
          [])
      ]);
      setAssignedOrgs(assignedOrg)
    }
  }


  const allVerticals =
    SurveyById && SurveyById.vertical && SurveyById.vertical.edges.map(({ node }) => getIntFromString(node.id));
  const allTeams = SurveyById && SurveyById.team && SurveyById.team.edges.map(({ node }) => getIntFromString(node.id));
  const allOrganizations =
    SurveyById && SurveyById.organization && SurveyById.organization.edges.map(({ node }) => getIntFromString(node.id));
  const renderOrgList = (org, header = false) => (
    // <Spin spinning={loading || actionLoading} size="large">

    <ListScroll
      header={header && <div align="center">Organizations</div>}
      // footer={<div>Footer</div>}
      bordered
      dataSource={(org && org?.edgeCount > 0 && org?.edges.map(({ node }) => node)) || []}
      renderItem={item => (
        <Selectable>
          {/* <OrganizationTree item={item} orgId={getIntFromString(item.id)} /> */}
          <List.Item onClick={() => { setOrgId(item.id); setTree(true); }}>
            <Row justify="space-between">
              <Col
                type="default"
                ghost

              >
                <img src={item?.logo ? item?.logo : IMG} alt="" style={{ width: 40, borderRadius: 30, marginRight: 10 }} /> {`${item.name}`}
              </Col>
            </Row>
          </List.Item>
        </Selectable>
      )}
    />
    // </Spin>
  );









  return (
    <>
      <Button type="primary" ghost onClick={() => setAssign(true)}>
        Survey Assigned
      </Button>

      <Modal
        destroyOnClose
        visible={assign}
        onCancel={() => setAssign(false)}
        centered
        footer={null}
        title="Assign Survey"
        width={'45%'}
        bodyStyle={{ padding: 16, minHeight: '80%' }}
      >
        {visible ? (
          <>
            <Row wrap={false}>
              <Button type="primary" onClick={() => setVisible(false)}>
                Assigned
              </Button>
            </Row>
            <br />
            {SurveyById && renderOrgList(assignedOrgs, true)}
          </>
        ) : (
          <>
            {/* <Spin spinning={loading || actionLoading} size="large"> */}

            <Row justify="space-between">
              <Button type="primary" onClick={() => setVisible(true)}>
                All Organizations
              </Button>

              <SelectFilterField
                placeholder="Search Organization by"
                onFiltersRemove={onFiltersRemove}
                options={[
                  {
                    label: 'Name',
                    type: 'text',
                    value: onNameChange
                  },
                  {
                    label: 'Description',
                    type: 'text',
                    value: onDescriptionChange
                  },
                  {
                    label: 'Email',
                    type: 'text',
                    value: onEmailChange
                  }
                ]}
              />
            </Row>
            {/* </Spin> */}
            <br />

            {allOrganization && allOrganization.edgeCount > 0 && (
              <ListScroll
                header={<div align="center">Organizations</div>}
                // footer={<div>Footer</div>}
                bordered
                dataSource={
                  allOrganization &&
                  allOrganization.edgeCount > 0 &&
                  allOrganization.edges
                    .filter(({ node }) => assignedOrgs?.edges?.map(({ node }) => node.id).indexOf(node.id) === -1)
                    .map(({ node }) => node)
                }
                renderItem={item => (
                  <Selectable>
                    {/* <OrganizationTree item={item} orgId={getIntFromString(item.id)} /> */}
                    <List.Item onClick={() => {
                      setOrgId(item.id);
                      setTree(true);
                    }}>
                      <Row justify="space-between" wrap={false}>
                        <Col
                          type="default"
                          ghost

                        >
                          <img src={item.logo || IMG} alt="" style={{ width: 40, borderRadius: 40, marginRight: 10 }} />{' '}
                          {`${item.name}`}
                        </Col>
                      </Row>
                    </List.Item>
                  </Selectable>
                )}
              />
            )}
          </>
        )}
      </Modal>

      <Modal
        destroyOnClose
        centered
        visible={tree}
        onCancel={() => setTree(false)}
        footer={null}
        title="Survey Assigned"
        width={'80%'}
        bodyStyle={{ padding: 16, maxHeight: '80vh', overflowX: 'scroll' }}
      >
        {/* <Spin spinning={actionLoading} size="large"> */}

        {tree && (
          <OrganizationTreeSurveyAssign
            refreshCounter={refreshCounter}
            triggerSubscriptionFetch={triggerSubscriptionFetch}
            actionLoading={actionLoading}
            setActionLoading={setActionLoading}
            key={JSON.stringify(allVerticals)} // This will remount the component when verticals change
            orgId={getIntFromString(orgId)}
            surveyId={SurveyById.id}
            surveyName={SurveyById.name}
            allVerticals={allVerticals}
            allTeams={allTeams}
            allOrganizations={allOrganizations}
            updateSurvey={updateSurvey}
          />
        )}
        {/* </Spin> */}
      </Modal>

    </>
  );
};

const Selectable = styled.div`
  &:hover {
    cursor: pointer;
    background-color: #fffff0;
  }
`;

const ListScroll = styled(List)`
  .ant-list-items {
    max-height: 60vh;
    overflow-y: scroll;
  }
`;
export default compose(
  withOrganizationState,
  withAllOrganization,
  withOrganizationFilterUpdating,
  withAdminPanelEditSurvey,
  withApollo
)(SurveyAssign);
